import React from 'react'
import ArticlesOverview from '../../../react4xp/components/ArticlesOverview'

function ArticlesOverviewPart({ title, intro, endpoint, highlightedArticle, firstPageArticles, hasSecondPage, pageNumber, total, solutions, strings }) {
    return (
        <ArticlesOverview
            title={title}
            intro={intro}
            endpoint={endpoint}
            highlightedArticle={highlightedArticle}
            firstPageArticles={firstPageArticles}
            hasSecondPage={hasSecondPage}
            pageNumber={pageNumber}
            total={total}
            solutions={solutions}
            strings={strings}
        />
    )
}

export default (props) => <ArticlesOverviewPart {...props} />
